<template>
  <div id="fmh-indikatoren-app">
    <Tabs />
  </div>
</template>

<script>
// setting chart props on window.Apex
import '@/components/ChartPartials/setApexChartsDefaults';
import Tabs from '@/components/Tabs';

export default {
  name: 'App',
  components: {
    Tabs
  }
};
</script>
<style>
#fmh-indikatoren-app {
  max-width: 1256px;
  margin: 0 auto;
}
</style>
